module.exports = __webpack_public_path__ + "static/media/icon-weight-management.d8e69e94.svg";